module.exports = __webpack_public_path__ + "static/media/saint-kitts-and-nevis.37ebc254.png";